/**
 *
 * RetakeButton
 *
 */

import React, { useContext } from 'react';
import _classNames from 'classnames';
import { useHistory, useParams } from 'react-router-dom';
import _get from 'lodash/get';
import useSiteCopySelector from 'components/useSiteCopySelector';
import Mixpanel, { injectAssessmentResultsABData } from 'utils/mixpanelService';
import AssessmentResultContext from 'containers/AssessmentResult/AssessmentResultContext';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(theme => ({
  button: {
    display: 'flex',
    padding: '12px 40px',
    borderRadius: 4,
    justifyContent: 'center',
    marginLeft: 8,
    marginRight: 8,
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      width: '100%',
      marginTop: 16,
    },
    ...theme.typography.caption,
  },
  tight: {
    padding: '10px 15px',
    minWidth: 'unset',
    fontSize: '0.875rem',
    lineHeight: '1.5',
    fontFamily: 'Mada',
    fontWeight: 700,
    textTransform: 'none',
    height: 'fit-content',
  },
}));

function RetakeButton({
  tight = false,
  variant = 'contained',
  trackingProps = {},
}) {
  const classes = useStyles();
  const [assessmentResultsSiteCopy] = useSiteCopySelector([
    'assessment-results',
  ]);
  const { slug } = useParams();
  const history = useHistory();
  const { shouldABTest, isVariantB } = useContext(AssessmentResultContext);

  const handleRetakeClick = () => {
    history.push(`/assessments/${slug}`);

    Mixpanel.track(
      `Assessment Results - Retake - Clicked`,
      injectAssessmentResultsABData(
        {
          slug,
          page: window.location.pathname,
          ...trackingProps,
        },
        shouldABTest,
        isVariantB,
      ),
    );
  };

  return (
    <Button
      variant={variant}
      color="primary"
      className={_classNames(classes.button, { [classes.tight]: tight })}
      onClick={handleRetakeClick}
    >
      {_get(assessmentResultsSiteCopy, 'pageCopy.retakeLabel')}
    </Button>
  );
}

export default RetakeButton;
